<div style="height: 100%;position: relative;">
  <div class="element desktop" (click)="globalService.isLogged ? openAccount() : loginInit()"
    [ngClass]="{'hover': hover}">
    <app-icon
      icon="user_circle"
    >
    </app-icon>
  </div>

  <div class="element mobile" (click)="globalService.isLogged ? openAccount() : loginInit()">
    <app-icon
      icon="user_circle"
    >
    </app-icon>
  </div>

</div>
